import _ from 'lodash';
import { getCountry } from '../../iwIntlProvider/CountryProvider';

export function isTradingDataLocation(location) {
    return ['/trading/', '/link-open-banking/'].includes(location.pathname);
}

function isDEBankStatementGroup(documentType) {
    return _.includes(
        ['bank statement', 'personal bank statement'],
        documentType
    );
}

function isDEManagementAccountsGroup(documentType) {
    return _.includes(
        [
            'management accounts',
            'business account',
            'pnl and balance',
            'profit and loss',
            'balance sheet',
            'management and balance accounts',
            'year end management and balance accounts',
            'year end management accounts',
            'account balances'
        ],
        documentType
    );
}

function isDEOtherGroup(documentType) {
    return _.includes(
        [
            'other',
            'aged debtor report',
            'vat return',
            'business plan',
            'invoices',
            'company bylaws',
            'trade certificate',
            'articles of association',
            'self assessment tax return',
            'customer broker consent',
            'cash register',
            'nif card',
            'modelo',
            'certificados'
        ],
        documentType
    );
}

function isDEShareholderID(documentType) {
    return _.includes(
        ['shareholder id', 'limited partner id', 'list of shareholders'],
        documentType
    );
}

export function groupByDocumentType(documents) {
    if (getCountry() !== 'DE') {
        return _.groupBy(documents, 'attributes.document_type');
    }

    const groupedDocuments = documents.map((document) => {
        const docType = document.attributes.document_type;

        if (isDEBankStatementGroup(docType)) {
            document.attributes.document_type = 'bank statement';
        }

        if (isDEManagementAccountsGroup(docType)) {
            document.attributes.document_type = 'management accounts';
        }

        if (isDEOtherGroup(docType)) {
            document.attributes.document_type = 'other';
        }

        if (isDEShareholderID(docType)) {
            document.attributes.document_type = 'shareholder id';
        }

        return document;
    });

    return _.groupBy(groupedDocuments, 'attributes.document_type');
}

export function deserialiseLinkedOpenBankingAccounts(
    onlineAccounts,
    openBankingProviders
) {
    const linkedAccounts = onlineAccounts;
    const openBankingProviderNames =
        pluckOpenBankingProviderNames(openBankingProviders);

    return linkedAccounts
        .filter((linkedAccount) =>
            filterLinkedOpenBankingAccounts(
                linkedAccount,
                openBankingProviderNames
            )
        )
        .filter(filterExpiredLinkedOpenBankingAccounts)
        .map((linkedAccount) => {
            return addBankNameToLinkedAccount(
                linkedAccount,
                openBankingProviders
            );
        })
        .map(deserialiseLinkedOpenBankingAccount);
}

function filterExpiredLinkedOpenBankingAccounts(linkedOpenBankingAccount) {
    if (!linkedOpenBankingAccount.status) return false;
    if (linkedOpenBankingAccount.status.code !== 'active') return false;

    return true;
}

function deserialiseLinkedOpenBankingAccount(linkedOpenBankingAccount) {
    const connectedAccounts = linkedOpenBankingAccount.accounts;

    return {
        bankName: linkedOpenBankingAccount.bank_name,
        providerId: linkedOpenBankingAccount.online_account_id,
        accountServiceProviderId: linkedOpenBankingAccount.provider,
        linkedAt: linkedOpenBankingAccount.linked_at,
        accounts: connectedAccounts.map(deserialiseAccount),
        status: linkedOpenBankingAccount.status?.code
    };
}

function deserialiseAccount(onlineAccount) {
    const extraAccountInformation = onlineAccount.extra || {};

    return {
        name: onlineAccount.name,
        balance: extraAccountInformation.balance,
        accountNumber: extraAccountInformation.account_number
    };
}

function pluckOpenBankingProviderNames(openBankingProviders) {
    return openBankingProviders.map((provider) => provider.bank_name);
}

function filterLinkedOpenBankingAccounts(
    linkedAccount,
    openBankingProviderNames
) {
    return openBankingProviderNames.includes(linkedAccount.provider);
}

function addBankNameToLinkedAccount(linkedAccount, openBankingProviders) {
    const accountBank = _.find(openBankingProviders, [
        'bank_name',
        linkedAccount.provider
    ]);
    linkedAccount.bank_name = accountBank.bank_name;

    return linkedAccount;
}
